import { Button, Icon, useTranslation } from '@testsigma/atoms';
import React from 'react';
import { showChatbot } from '../../shared/components/salesforce-chat';

const UserLimitBanner = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <div className='w-full relative flex flex-row items-center justify-center'>
      <div className='flex items-center justify-between w-full'>
        <span className='text-sm text-unique-600 font-semibold mr-4'>
          {t('user.limit_exceeded_banner')}
        </span>
        <div className='flex justify-between gap-3'>
          <Button
            type='primary-transparent'
            className='flex items-center justify-center py-2 hover:!bg-transparent !border !border-unique-600'
            onClick={() =>
              window.open(
                `mailto::${t('mailboxes.empty-state-description.support')}`,
                '_blank',
              )
            }>
            <Icon name='headset-mic' className='text-sm mr-2 text-unique-600' />
            <span className='text-unique-600'>{t('billing.plan.support')}</span>
          </Button>
          <Button
            type='primary-transparent'
            className='flex items-center justify-center py-2 hover:!bg-transparent !border !border-unique-600 whitespace-nowrap'
            //@ts-ignore
            onClick={() => showChatbot()}>
            <Icon name='chat' className='text-sm mr-2 text-unique-600' />
            <span className='text-unique-600'>
              {t('billing.plan.chat_with_us')}
            </span>
          </Button>

          <Icon
            name='close'
            className='text-[24px] text-secondary-500 items-center cursor-pointer'
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default UserLimitBanner;
